import { api } from 'api'
import { path } from 'ramda'
import { ShiftEditData } from './typings'

export async function getShiftForEdit(id: number) {
  const data = await api.post(
    '/company/graphql_dispatch/shift_detail_64b380f9',
    {
      id,
    }
  )

  return path(
    ['data', 'data', 'company', 'shiftsDetail', 0],
    data
  ) as ShiftEditData
}
